module.exports = __webpack_public_path__ + "img/sousuo-copy.038d459d.png";